export default "__VITE_ASSET__7PZHqFB5__"